export default function Results() {
  const results = [
    {
      icon: 'ri-eye-line',
      title: 'Полный контроль и прозрачность расходов',
      description: 'Видите каждый рубль и понимаете, куда он идет и какой результат приносит',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Системный рост дохода каждый месяц',
      description: 'Предсказуемое увеличение прибыли благодаря отлаженным процессам',
    },
    {
      icon: 'ri-team-line',
      title: 'Автономный отдел маркетинга',
      description: 'Система работает без вашего постоянного участия, освобождая время для бизнеса',
    },
    {
      icon: 'ri-trophy-line',
      title: 'Доминирование в поисковиках',
      description: 'Ваши товары и услуги на первых позициях, опережая конкурентов',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Поток лояльных клиентов',
      description: 'Не просто покупатели, а адвокаты бренда, которые возвращаются снова',
    },
    {
      icon: 'ri-funds-line',
      title: 'Оптимизация бюджета до 40%',
      description: 'Алгоритмы находят самые эффективные каналы и отсекают неработающие',
    },
  ];

  return (
    <section className="py-24" style={{ background: '#FFFFFF' }}>
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-sm font-semibold tracking-widest uppercase mb-4"
            style={{ color: '#C5A880', fontFamily: 'Montserrat, sans-serif' }}
          >
            Результаты внедрения
          </p>
          <h2
            className="text-4xl md:text-5xl font-bold mb-6"
            style={{ color: '#1A2B4C', fontFamily: 'Playfair Display, serif' }}
          >
            Что вы получите после внедрения системы?
          </h2>
          <div className="w-16 h-0.5 mx-auto mb-6" style={{ background: '#C5A880' }}></div>
          <p
            className="text-lg max-w-2xl mx-auto"
            style={{ color: '#4A5568', fontFamily: 'Montserrat, sans-serif' }}
          >
            Конкретные результаты, которые изменят ваш бизнес
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {results.map((result, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
              style={{ border: '1px solid #E8E0D5' }}
            >
              {/* Icon + check row */}
              <div className="flex items-center justify-between mb-6">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ background: '#F8F9FA', border: '1px solid #E8E0D5' }}
                >
                  <i className={`${result.icon} text-2xl`} style={{ color: '#1A2B4C' }}></i>
                </div>
                <div
                  className="w-7 h-7 rounded-full flex items-center justify-center"
                  style={{ background: '#C5A880' }}
                >
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
              </div>

              {/* Thin gold line */}
              <div className="w-8 h-0.5 mb-5 transition-all duration-300 group-hover:w-16" style={{ background: '#C5A880' }}></div>

              <h3
                className="text-lg font-bold mb-3"
                style={{ color: '#1A2B4C', fontFamily: 'Playfair Display, serif' }}
              >
                {result.title}
              </h3>
              <p
                className="text-sm leading-relaxed"
                style={{ color: '#6B7280', fontFamily: 'Montserrat, sans-serif' }}
              >
                {result.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA banner */}
        <div
          className="rounded-3xl p-12 text-center shadow-2xl relative overflow-hidden"
          style={{ background: '#1A2B4C' }}
        >
          {/* Decorative rings */}
          <div
            className="absolute -top-16 -right-16 w-64 h-64 rounded-full opacity-10"
            style={{ border: '2px solid #C5A880' }}
          ></div>
          <div
            className="absolute -bottom-20 -left-20 w-80 h-80 rounded-full opacity-10"
            style={{ border: '2px solid #C5A880' }}
          ></div>

          <div className="relative max-w-3xl mx-auto">
            <div
              className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-6"
              style={{ background: 'rgba(197,168,128,0.15)', border: '1px solid #C5A880' }}
            >
              <i className="ri-rocket-2-line text-2xl" style={{ color: '#C5A880' }}></i>
            </div>
            <h3
              className="text-3xl md:text-4xl font-bold text-white mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Готовы к трансформации?
            </h3>
            <p
              className="text-lg mb-8"
              style={{ color: 'rgba(255,255,255,0.75)', fontFamily: 'Montserrat, sans-serif' }}
            >
              Первые результаты вы увидите уже через 30 дней после запуска системы
            </p>
            <button
              onClick={() => {
                const element = document.getElementById('lead-form');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-3 px-10 py-4 rounded-xl font-semibold text-base transition-all duration-300 hover:opacity-90 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
              style={{ background: '#C5A880', color: '#1A2B4C', fontFamily: 'Montserrat, sans-serif' }}
            >
              Начать прямо сейчас
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
